import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { LatestIssueCallout } from './LatestIssueCallout';
import { NewsletterArchive } from './NewsletterArchive';
import { SubmitContent } from './SubmitContent';
import { QuickLinks } from './QuickLinks';
export function NewsletterPage() {
  return <PageLayout data-id="element-2235">
      <HeaderBanner data-id="element-2236" />
      <LatestIssueCallout data-id="element-2237" />
      <NewsletterArchive data-id="element-2238" />
      <SubmitContent data-id="element-2239" />
      <QuickLinks data-id="element-2240" />
    </PageLayout>;
}